export default "__VITE_ASSET__RmVkCb24__"